import { motion } from 'framer-motion';

const SectionHeading = ({
  eyebrow,
  title,
  text,
  light = false,
  center = false,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
      className={`${center ? 'mx-auto text-center' : ''} max-w-3xl`}
    >
      {/* Eyebrow (etiqueta superior) */}
      {eyebrow && (
        <p className="mb-4 font-bold uppercase tracking-[.24em] text-[#94cf1c] text-base">
          {eyebrow}
        </p>
      )}

      {/* Título principal */}
      <h2
        className={`text-3xl font-bold leading-tight tracking-tight md:text-5xl text-[#00a7e2] ${
          light ? 'text-white' : ''
        }`}
      >
        {title}
      </h2>

      {/* Texto descriptivo (opcional) */}
      {text && (
        <p
          className={`mt-5 text-lg leading-8 text-justify ${
            light ? 'text-blue-100' : 'text-slate-600'
          }`}
        >
          {text}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeading;